<template>
	<div id="intro-cn">
		<div class="img-box">
			<div class="top_part">
				<img class="top-back-img" src="@/assets/active/intro/11.png" alt="">
				<div class="link-wrapper">
					<span>
						<img class="icon" src="@/assets/active/intro/tg.png" alt="">
						<a href="https://t.me/jinguozi001" target="">https://t.me/jinguozi001</a>
						<span class="copy my_code" @click="copy('https://t.me/jinguozi001')">
							<img class="mr4" src="@/assets/active/intro/copy.png">
						</span>
					</span>
					<span>
						QQ: 666376678
						<span class="copy my_code" @click="copy('666376678')">
							<img src="@/assets/active/intro/copy.png">
						</span>
					</span>
					<div class="tip-box">
						<span class="mr">(量化爱好者交流群)</span>
						<span>(量化爱好者交流群)</span>
					</div>
				</div>
			</div>
			<div class="middle-part">
				<img src="@/assets/active/intro/22.png" alt="">
			</div>
			<div class="third-part">
				<img src="@/assets/active/intro/33.png" alt="">
			</div>
			<div class="third-part-1">
				<img src="@/assets/active/intro/44.png" alt="">
			</div>
			<div class="four-part">
				<img src="@/assets/active/intro/55.png" alt="">
				<!-- <div class="phone-box">
                    <span class="tme">jinguozi001</span>
                    <span class="copy my_code" @click="copy('jinguozi001')">
                        <img src="@/assets/active/intro/copy.png">
                    </span>
                </div>
                <div class="tme-box">
                    <span class="tme">https://t.me/jinguozi001</span>
                    <span class="copy my_code" @click="copy('https://t.me/jinguozi001')">
                        <img src="@/assets/download/copy.png">
                    </span>
                </div> -->
			</div>

			<div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
				<span class="mask-tip">请在浏览器中打开</span>
				<img src="@/assets/down/tip_arrow.png" />
			</div>
		</div>
		<div class="alert" v-show="alertShow">
			<span>{{message}}</span>
		</div>
	</div>
</template>

<script>
	import Clipboard from 'clipboard'
	export default {
		data() {
			return {
				alertShow: false,
				message: ''
			}
		},
		methods: {
			copy( str ) {
				// let str = 'https://t.me/jinguozi001'
				let clipboard = new Clipboard( '.my_code', {
					text: function() {
						return str
					}
				} )
				console.log( clipboard )
				clipboard.on( 'success', e => {
					this.showAlert( '复制成功' )
					clipboard.destroy()
				} )
				clipboard.on( 'error', e => {
					this.showAlert( '复制失败，请长按邀请码进行复制' )
					clipboard.destroy()
				} )
			},
			showAlert( message ) {
				this.message = message;
				this.alertShow = true;
				setTimeout( () => {
					this.alertShow = false;
				}, 1500 );
			},
		}
	}
</script>

<style lang='less'>
	#intro-cn {
		height: 100vh;
		width: 100vw;
		background: #111125;
		;
		position: relative;

		// padding-bottom: 120px;
		img {
			pointer-events: none;
		}

		button {
			height: 90px;
			width: 460px;
			outline: none;
			border: none;
			cursor: pointer;
			border-radius: 45px;
			background: linear-gradient(90deg, #ff7800 0%, #ffc000 100%);
			box-shadow: -5px 0px 0px 0px rgba(255, 207, 152, 0.81);
			position: absolute;
			color: #ffffff;
			font-size: 32px;
			font-weight: bold;
			left: 145px;
		}

		.img-box {
			width: 100%;
			height: 100%;
			overflow: auto;
		}

		.top_part {
			width: 100vw;
			height: 1411px;
			position: relative;

			.top-back-img {
				// position: absolute;
				// left: 0;
				// top: 0;
				width: 100vw;
			}

			.link-wrapper {
				position: absolute;
				color: #ffffff;
				left: 0;
				top: 470px;
				width: 100vw;
				text-align: center;

				span {
					// margin-right: 20px;
					font-size: 28px;
					vertical-align: middle;
				}

				a {
					color: #ffffff;
					margin-right: 10px;
					vertical-align: middle;
				}

				.icon {
					width: 32px;
					height: 32px;
					vertical-align: middle;
					margin-right: 10px;
				}

				.copy {
					img {
						width: 34px;
						height: 34px;
						vertical-align: middle;
					}
				}

				.mr4 {
					margin-right: 40px;
				}

				.tip-box {
					margin-top: 10px;
					display: flex;
					justify-content: center;
					padding-left: 20px;

					span {
						font-size: 18px;
						line-height: 30px;
					}

					.mr {
						margin-right: 100px;
					}
				}
			}
		}

		.middle-part {
			position: relative;

			img {
				width: 100vw;
			}

			.button_box {
				width: 60vw;
				position: absolute;
				top: 265px;
				right: 40px;
				height: 90px;
				opacity: 0;
			}

			button {
				left: 0;
			}
		}

		.third-part {
			img {
				width: 100vw;
			}
		}

		.third-part-1 {
			img {
				width: 100vw;
			}
		}

		.four-part {
			position: relative;

			img {
				width: 100vw;
			}

			.phone-box {
				position: absolute;
				width: 330px;
				right: 0px;
				bottom: 690px;
				color: #ffffff;

				span {
					vertical-align: middle;
					margin-right: 20px;
				}

				img {
					vertical-align: middle;
					width: 50px;
					height: 50px;
				}
			}

			.tme-box {
				position: absolute;
				width: 400px;
				left: 60px;
				bottom: 120px;

				span {
					vertical-align: middle;
					margin-right: 20px;
				}

				img {
					vertical-align: middle;
					width: 50px;
					height: 50px;
				}
			}
		}

		.alert {
			position: fixed;
			z-index: 3;
			top: 40%;
			left: 50%;
			height: 60px;
			width: auto;
			padding: 0 30px;
			transform: translateX(-100px);
			border-radius: 8px;
			background: rgba(0, 0, 0, .9);
			color: #ffffff;
			line-height: 60px;
		}
	}
</style>